
// '//127.0.0.1:8080/ownerapi/'
let testUrl='//'+location.hostname+':'+location.port+'/ownerapi/';

let setRem = () => {
        let baseSize = 100,
            baseWidth = 750,
            width = document.body.clientWidth,
            size = baseSize;
        size = baseSize * width / baseWidth;


        document.getElementsByTagName('html')[0].style.fontSize = size + 'px';

        window.addEventListener('resize', function () {
            width = document.body.clientWidth;
            size = baseSize * width / baseWidth;
            document.getElementsByTagName('html')[0].style.fontSize = size + 'px';
        });
    },
    hostUrl = process.env.NODE_ENV === 'production' ? 'http://www.xmf119.com/' : testUrl

let url2json = (url) => {
        url = url.indexOf('?')>-1 ? url.substring(1) : url;
        
        let json = {};
        let arr = url.split('&');
        if (arr.length == 0) {
            return json;
        }
        arr.forEach(item => {
            let arr1 = item.split('=');
            json[arr1[0]] = arr1[1]
        })
        return json;
    }

    let addZero = (num,digit=2)=>{
        num=num+'';
        if(num.length<digit){
            let str='';
            for(var i=0;i<digit-num.length;i++){
                str+='0';
            }
            return str+num;
        }else{
            return num;
        }
    }

    export {
        setRem,
        hostUrl,
        url2json,
        addZero
    }